import Controller from '@ember/controller';
import { action, computed, set, setProperties } from '@ember/object';
import { sort } from '@ember/object/computed';

export default Controller.extend({
  sortProp: 'group',
  sortDir: 'asc',

  sortBy: computed('sortProp', 'sortDir', function () {
    return [`${this.sortProp}:${this.sortDir}`];
  }),

  sortedItems: sort('model', 'sortBy'),

  sort: action(function (property) {
    let currentSortProp = this.sortProp;
    if (currentSortProp === property) {
      if (this.sortDir === 'asc') {
        set(this, 'sortDir', 'desc');
      } else {
        set(this, 'sortDir', 'asc');
      }
    } else {
      setProperties(this, {
        sortProp: property,
        sortDir: 'desc',
      });
    }
  }),
});
